// @react/hooks/useChat.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { chatStore } from '@core/stores';

/**
 * React hook for Conversation operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useChat } from '@react/hooks';
 *
 * const ConversationList = observer(() => {
 *   const store = useChat();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useChat() {
  return chatStore;
}
